import { useContext } from 'react'
import { UploadContext } from '../../contexts/upload'

export const useUploadContext = () => {
  const context = useContext(UploadContext)

  if (!context) {
    throw new Error()
  }

  return context
}
